// extracted by mini-css-extract-plugin
module.exports = {"sizesDesktop":"ProductSizes_sizesDesktop__Keq0Y","sizesMobile":"ProductSizes_sizesMobile__Tpigb"};